
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"30","height":"30"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#222"}},[_c('path',{attrs:{"d":"M4.655 4l9.051 9.2a1.8 1.8 0 002.579 0l4.724-4.8-.021-.021 2.153-2.189.021.021L25.336 4z"}}),_c('path',{attrs:{"d":"M25.29 8.375l-2.149 2.189-5.562 5.652a3.614 3.614 0 01-5.166 0L1.275 4.887A1.849 1.849 0 001 5.854v17.333a1.844 1.844 0 001.824 1.85h24.344a1.844 1.844 0 001.824-1.85V5.854a1.864 1.864 0 00-.276-.967z"}})])])
          )
        }
      }
    